import axios from "axios"
import store from "store"
import { notification } from "ant-design-vue"

const jwtClient = axios.create({
  baseURL: "/v2/api",
  // timeout: 1000,
  // headers: { 'X-Custom-Header': 'foobar' }
})

jwtClient.interceptors.request.use(request => {
  const accessToken = store.get("accessToken")
  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`
    request.headers.AccessToken = accessToken
  }
  return request
})

jwtClient.interceptors.response.use(undefined, error => {
  // Errors handling
  const { response } = error
  const { data } = response
  if (data) {
    notification.warning({
      message: data,
    })
  }
})

export default jwtClient
